import { CardContent, TextField } from '@material-ui/core';
import { Elements } from '@stripe/react-stripe-js';
import PaymentCardFormContainer from '../../../containers/PaymentCardFormContainer';
import FancyCard from '../../../components/fancy/FancyCard';
import React from 'react';

function PaymentFormCard({ stripePromise, user, note, setNote }) {
    return (
        <FancyCard fullWidth>
            <CardContent>
                <Elements stripe={stripePromise}>
                    <PaymentCardFormContainer />
                    {user?.role === 'agent' && (
                        <TextField
                            fullWidth
                            label="Private agent notes (to identify the customer)"
                            name="cashnote"
                            placeholder="Fill out with the required information, like room number, booking identifier, etc."
                            type="text"
                            value={note}
                            onChange={ev => {
                                setNote(ev.target.value);
                            }}
                        />
                    )}
                </Elements>
            </CardContent>
        </FancyCard>
    );
}
export default PaymentFormCard;
